import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import TestRequestForm from "./TestRequestForm";

const TutorialPricingSection = () => {
  const offers = [
    {
      name: "TEST",
      duration: "24H - ESSAI",
      price: "GRATUIT",
      pricePerMonth: null,
      popular: false,
      isTest: true,
      cta: "ESSAYER GRATUITEMENT",
      ctaLink: "",
      features: [
        { text: "+15 000 CHAÎNES TV", included: true },
        { text: "+100 000 FILMS", included: true },
        { text: "+25 000 SÉRIES", included: true },
        { text: "FONCTIONNE DANS LE MONDE ENTIER", included: true },
        { text: "MISE À JOUR AUTO DU CONTENU", included: true },
        { text: "SUPPORT 7J/7", included: true },
      ],
    },
    {
      name: "3 MOIS",
      duration: "90 JOURS - ABONNEMENT",
      price: "25",
      pricePerMonth: "8,33",
      popular: false,
      isTest: false,
      cta: "PAYER MAINTENANT",
      ctaLink: "/nos-offres",
      features: [
        { text: "+15 000 CHAÎNES TV", included: true },
        { text: "+100 000 FILMS", included: true },
        { text: "+25 000 SÉRIES", included: true },
        { text: "FONCTIONNE DANS LE MONDE ENTIER", included: true },
        { text: "MISE À JOUR AUTO DU CONTENU", included: true },
        { text: "SUPPORT 7J/7", included: true },
      ],
    },
    {
      name: "6 MOIS",
      duration: "180 JOURS - ABONNEMENT",
      price: "40",
      pricePerMonth: "6,67",
      popular: false,
      isTest: false,
      cta: "PAYER MAINTENANT",
      ctaLink: "/nos-offres",
      features: [
        { text: "+15 000 CHAÎNES TV", included: true },
        { text: "+100 000 FILMS", included: true },
        { text: "+25 000 SÉRIES", included: true },
        { text: "FONCTIONNE DANS LE MONDE ENTIER", included: true },
        { text: "MISE À JOUR AUTO DU CONTENU", included: true },
        { text: "SUPPORT 7J/7", included: true },
      ],
    },
    {
      name: "12 MOIS",
      duration: "365 JOURS - ABONNEMENT",
      price: "60",
      pricePerMonth: "5",
      popular: true,
      isTest: false,
      cta: "PAYER MAINTENANT",
      ctaLink: "/nos-offres",
      features: [
        { text: "+15 000 CHAÎNES TV", included: true },
        { text: "+100 000 FILMS", included: true },
        { text: "+25 000 SÉRIES", included: true },
        { text: "FONCTIONNE DANS LE MONDE ENTIER", included: true },
        { text: "MISE À JOUR AUTO DU CONTENU", included: true },
        { text: "SUPPORT VIP 24/7", included: true },
      ],
    },
  ];

  return (
    <section className="py-16 px-4 bg-background">
      <div className="container mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-foreground tracking-wide">
            NOS OFFRES D'ABONNEMENT
          </h2>
          <p className="text-muted-foreground">
            Choisissez l'offre qui vous convient
          </p>
        </div>
        
        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {offers.map((offer, index) => (
            <Card 
              key={index} 
              className={`relative overflow-hidden transition-all duration-300 hover:scale-105 rounded-xl border-2 flex flex-col ${
                offer.popular 
                  ? 'bg-gradient-to-b from-primary to-primary/80 border-primary glow-primary' 
                  : 'bg-card border-primary/40 hover:border-primary/80'
              }`}
            >
              <CardContent className="p-6 text-center flex flex-col flex-1">
                {/* Nom */}
                <h3 className={`text-2xl font-bold mb-2 tracking-wider ${
                  offer.popular ? 'text-primary-foreground' : 'text-primary'
                }`}>
                  {offer.name}
                </h3>
                <p className={`text-sm mb-4 tracking-wide ${
                  offer.popular ? 'text-primary-foreground/80' : 'text-muted-foreground'
                }`}>
                  {offer.duration}
                </p>
                
                {/* Prix */}
                <div className="mb-4 min-h-[80px]">
                  <div className={`text-5xl font-black ${
                    offer.popular ? 'text-primary-foreground' : 'text-foreground'
                  }`}>
                    {offer.isTest ? offer.price : `${offer.price} €`}
                  </div>
                  {offer.pricePerMonth ? (
                    <p className={`text-sm mt-1 ${
                      offer.popular ? 'text-primary-foreground/70' : 'text-muted-foreground'
                    }`}>
                      soit {offer.pricePerMonth} €/mois
                    </p>
                  ) : (
                    <p className="text-sm mt-1 invisible">-</p>
                  )}
                </div>
                
                {/* CTA */}
                {offer.isTest ? (
                  <div className="w-full mb-6">
                    <TestRequestForm
                      trigger={
                        <Button 
                          className="w-full font-bold py-5 text-sm rounded-full transition-all duration-300 group btn-primary text-primary-foreground"
                        >
                          {offer.cta}
                          <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                        </Button>
                      }
                    />
                  </div>
                ) : (
                  <Link 
                    to={offer.ctaLink}
                    className="w-full block mb-6"
                  >
                    <Button 
                      className={`w-full font-bold py-5 text-sm rounded-full transition-all duration-300 group ${
                        offer.popular 
                          ? 'bg-background text-foreground hover:bg-background/90' 
                          : 'btn-primary text-primary-foreground'
                      }`}
                    >
                      {offer.cta}
                      <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                )}
                
                {/* Features */}
                <ul className="space-y-3 text-left mb-4 flex-1">
                  {offer.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="text-secondary flex-shrink-0">✅</span>
                      <span className={`text-sm ${
                        offer.popular ? 'text-primary-foreground/90' : 'text-foreground/80'
                      }`}>
                        {feature.text}
                      </span>
                    </li>
                  ))}
                </ul>
                
                {/* Tutoriels */}
                <div className={`pt-4 border-t text-left text-xs ${
                  offer.popular ? 'border-primary-foreground/20' : 'border-border'
                }`}>
                  <p className={offer.popular ? 'text-primary-foreground/80' : 'text-muted-foreground'}>
                    📚 Tutoriels fournis par email + disponibles sur{' '}
                    <Link 
                      to="/tutoriels" 
                      className={`underline hover:no-underline ${
                        offer.popular ? 'text-black font-semibold' : 'text-primary'
                      }`}
                    >
                      la page Tutoriels
                    </Link>
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TutorialPricingSection;